import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './screen/Home';

function App() {
  return (
    <Router>
    <div>
    <Routes>
     <Route exact path='/' element={<Home/>}/>
    </Routes>      
    </div>
    </Router>
  );
}

export default App;
